.loginContent {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 72vh;
  padding: 3rem 1.5rem 4rem;
  background-color: var(--ib-blush);
}

.cardWrapper {
  width: 100%;
  max-width: 440px;
  display: flex;
  justify-content: center;
}

.card {
  width: 100%;
  padding: 2rem;
  background-color: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 10px 30px rgba(120, 30, 30, 0.08);
  display: flex;
  flex-direction: column;
}

.heading {
  font-family: var(--font-serif);
  letter-spacing: -0.01em;
}

.welcomeText {
  margin: 0.5rem 0 1.5rem 0;
}

.inputs {
  display: flex;
  flex-direction: column;
}

.input {
  position: relative;
  margin-bottom: 1rem;
}

/* Restyle the actual <input> rendered inside the Input component wrapper */
.input input {
  width: 100%;
  border: 1px solid var(--ib-line);
  border-radius: 8px;
  padding: 0.65rem 0.85rem;
  color: var(--ib-ink);
  font-variant-numeric: tabular-nums lining-nums;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input input:focus {
  outline: 0;
  border-color: var(--ib-red);
  box-shadow: 0 0 0 3px var(--ib-red-soft);
}

.toggleBtn {
  align-self: flex-end;
  padding: 0;
  margin: 0 0 0.5rem;
}

.errorMessage {
  display: flex;
  flex-direction: column;
  min-height: 1rem;
  margin: 0.25rem 0 0.25rem;
  padding-left: 0.1rem;
}

.card .primaryBtn {
  width: 100%;
  border-radius: 8px;
  padding: 0.7rem 1rem;
  font-weight: 600;
  margin-top: 0.5rem;
}

.card .primaryBtn:not(:disabled) {
  background-color: var(--ib-red);
  border-color: var(--ib-red);
}

.card .primaryBtn:not(:disabled):hover {
  background-color: var(--ib-red-d);
  border-color: var(--ib-red-d);
}

.forgotRow {
  margin-top: 1rem;
  text-align: center;
}

.divider {
  height: 1px;
  background: var(--ib-line);
  margin: 1.5rem 0;
}

.card .registerButton {
  width: 100%;
  border-radius: 8px;
  padding: 0.6rem 1rem;
}

.card .registerButton:hover {
  border: 1px solid var(--login-hvr-color);
}

/* password login path */
.passwordInputWrapper {
  position: relative;
  margin-bottom: 1rem;
}

.passwordInputWrapper input {
  padding-right: 3.4rem;
}

.passwordInput {
  margin-bottom: 0;
}

.passwordBtn {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  z-index: 2;
}

@media (max-width: 767.98px) {
  .loginContent {
    padding: 2rem 1rem 3rem;
    min-height: 68vh;
  }

  .card {
    padding: 1.5rem;
  }
}
